class GlobalCollectionFilters extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    this.form = this.querySelector("#global-collection-filters-form");
    this.header = this.querySelector("global-collection-filters-header");
    this.flyout = this.querySelector("global-collection-filters-flyout");
    this.initEventListeners();
  }
  disconnectedCallback() {}

  initEventListeners() {
    this.form.addEventListener("input", this.formInputEventHandler.bind(this));
  }

  formInputEventHandler(event) {
    const input = event.target;
    const isSortDropdown = input.closest("#sort-dropdown-options");

    if (isSortDropdown) {
      this.form.submit();
    }
  }
}

class CollectionFiltersHeader extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    this.header = this.querySelector("#global-collection-filters-header");
    this.filters = this.querySelector("#cta-filters");
    this.sortDropdown = this.querySelector("#sort-dropdown-options");
    this.flyout = document.querySelector("global-collection-filters-flyout");
    this.collection = document.querySelector("#product-loop");
    this.form = document.querySelector("#global-collection-filters-form");

    this.initEventListeners();
    this.initStickyBar();
  }

  disconnectedCallback() {}

  initEventListeners() {
    this.filters.addEventListener("click", this.toggleFlyout.bind(this));
  }

  toggleFlyout() {
    this.flyout.classList.toggle("show-flyout-filters");
    this.collection.classList.toggle("opened-flyout-filters");
    this.filters.classList.toggle("opened-flyout-filters");
  }

  initStickyBar() {
    /*if (
      sessionStorage.getItem("ig-variation") !=
      "b159441f-3c67-409b-876a-668617007f95"
    ) {
      return;
    }*/

    // FIXME:  Inteligems Test ID
    let rootMarginval;
    if (
      sessionStorage.getItem("ig-variation") ===
      "2a7d6254-6f0b-4f6f-92e4-a30be64aec6d"
    ) {
      // if it has sticky search bar
      rootMarginval = "-18px 0px 0px 0px";
    } else {
      // if it does not have sticky search bar
      rootMarginval = "40px 0px 0px 0px";
    }

    const observer = new IntersectionObserver(
      (entries) => {
        if (entries[0].isIntersecting) {
          this.header.classList.remove("sticky-collection-filters");
        } else {          
          if (window.innerWidth < 769) {
            // code for mobile view
            this.header.classList.add("sticky-collection-filters");
          }
        }
      },
      {
        threshold: 1,
        rootMargin: rootMarginval,
      }
    );
    observer.observe(document.querySelector(".icon-description-blockwrapper"));
  }
}

class CollectionQuickFilterButtons extends HTMLElement {
  constructor() {
    super();
    this.currentCollectionGrid = document.querySelector("#product-loop");
    this.currentCollectionPagination = document.querySelector("#pagination");
    this.currentCollectionGridContent = "";
    this.currentCollectionPaginationContent = "";
  }

  connectedCallback() {
    this.grid = this.querySelector("#collection-filter-buttons-grid");
    this.flyout = document.querySelector("global-collection-filters-flyout");
    this.grid.addEventListener("click", this.clickEventHandler.bind(this));
    this.cacheCurrentCollection();
  }

  disconnectedCallback() {
    this.grid.removeEventListener("click", this.clickEventHandler.bind(this));
  }

  clickEventHandler(event) {
    const btn = event.target.closest("button");
    if (!btn) return;
    const { filterValuesHandles } = btn.dataset;

    if (btn.dataset.activeFilter == "true") {
      btn.dataset.activeFilter = "false";
      this.restoreCurrentCollection();
      return;
    }

    this.resetActiveButtons();
    btn.dataset.activeFilter = true;
    this.filterCollection(filterValuesHandles, btn);
  }

  async filterCollection(valuesHandles, button) {
    const values = valuesHandles.split("::");
    this.flyout.persistFilters(values);
    const searchFilterParams = this.createSearchFilterParams(values);
    this.setLoadingButton(button, true);
    try {
      const filterCollectionUrl = `${window.location.origin}${window.location.pathname}?${searchFilterParams}`;
      const collectionRequest = await fetch(filterCollectionUrl);
      const collectionResponse = await collectionRequest.text();
      const document = this.parseHTMLResponse(collectionResponse);
      this.replaceCollectionContent(document);
    } catch (error) {
      console.log(`Global Collection Filters | filterCollection | ${error}`);
    } finally {
      this.setLoadingButton(button, false);
    }
  }

  replaceCollectionContent(newContent) {
    const productLoop = newContent.querySelector("#product-loop");
    const pagination = newContent.querySelector("#pagination");
    if (!productLoop && !pagination) return;
    this.currentCollectionGrid.innerHTML = productLoop.innerHTML;
    if (pagination)
      this.currentCollectionPagination.innerHTML = pagination.innerHTML;
  }

  createSearchFilterParams(values) {
    return values
      .map((item) => {
        const decodedValue = item.replace(/\+/g, " ");
        return `filter.p.m.custom.product_type_sozy=${encodeURIComponent(decodedValue)}`;
      })
      .join("&");
  }

  resetActiveButtons() {
    this.grid
      .querySelectorAll("button")
      .forEach((btn) => (btn.dataset.activeFilter = false));
  }

  setLoadingButton(button, flag) {
    const { filterName } = button.dataset;
    button.dataset.disabled = flag;
    button.innerHTML = `<span>${flag ? "Loading..." : filterName}</span>`;
  }

  parseHTMLResponse(response) {
    const parser = new DOMParser();
    return parser.parseFromString(response, "text/html");
  }

  cacheCurrentCollection() {
    this.currentCollectionGridContent = this.currentCollectionGrid.innerHTML;
    this.currentCollectionPaginationContent =
      this.currentCollectionPagination.innerHTML;
  }
  restoreCurrentCollection() {
    this.currentCollectionGrid.innerHTML = this.currentCollectionGridContent;
    this.currentCollectionPagination.innerHTML =
      this.currentCollectionPaginationContent;
  }
}

class CollectionFiltersFlyout extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    this.openBtn = document.querySelector("#cta-filters");
    this.closeBtn = this.querySelector("#close-flyout-button");
    this.closeBtn.addEventListener("click", this.closeEventHandler.bind(this));
  }

  disconnectedCallback() {}

  closeEventHandler() {
    this.classList.remove("show-flyout-filters");
    this.openBtn.classList.remove("opened-flyout-filters");
  }

  persistFilters(values) {
    const formattedValues = values.map((el) => el.replace(/\+/g, " "));

    this.resetFilters();

    formattedValues.forEach((val) => {
      const input = this.querySelector(`input[value="${CSS.escape(val)}"]`);
      if (input) {
        input.checked = true;
      }
    });
  }

  resetFilters() {
    this.querySelectorAll(`input[type="checkbox"]:checked`).forEach(
      (el) => (el.checked = false)
    );
  }
}

class FiltersFlyoutPrices extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.list = this.querySelector(".filters-flyout-prices-list");
    this.list.addEventListener("click", this.clickEventHandler.bind(this));
    this.persistPriceFilter();
  }

  disconnectedCallback() {
    this.list.removeEventListener("click", this.clickEventHandler.bind(this));
  }

  clickEventHandler(event) {
    const label = event.target.closest(".filter-flyout-price-label");
    if (!label) return;
    const container = label.closest(".filters-flyout-prices-container");
    this.resetInputsAndCheckboxes();
    container
      .querySelectorAll(`input[type="hidden"]`)
      .forEach((input) => (input.disabled = false));
    container
      .querySelector(".global-collection-filter--checkbox-placeholder")
      .classList.add("active-filter");
  }

  resetInputsAndCheckboxes() {
    this.querySelectorAll(
      ".global-collection-filter--checkbox-placeholder"
    ).forEach((el) => el.classList.remove("active-filter"));

    this.querySelectorAll(`input[type="hidden"]`).forEach(
      (el) => (el.disabled = true)
    );
  }

  persistPriceFilter() {
    const param = new URLSearchParams(window.location.search);
    const pricegte = param.get("filter.v.price.gte");
    const pricelte = param.get("filter.v.price.lte");
    const pricegteinput = this.querySelector(
      `input[type="hidden"][name="filter.v.price.gte"][value="${pricegte}"]`
    );
    const pricelteinput = this.querySelector(
      `input[type="hidden"][name="filter.v.price.lte"][value="${pricelte}"]`
    );

    if (pricegteinput) {
      pricegteinput.disabled = false;
      let pricecontainer = pricegteinput.closest(
        ".filters-flyout-prices-container"
      );
      pricecontainer
        .querySelector(".global-collection-filter--checkbox-placeholder")
        .classList.add("active-filter");
    }
    if (pricelteinput) {
      pricelteinput.disabled = false;
      let pricecontainer = pricelteinput.closest(
        ".filters-flyout-prices-container"
      );
      pricecontainer
        .querySelector(".global-collection-filter--checkbox-placeholder")
        .classList.add("active-filter");
    }
  }
}

customElements.define("global-collection-filters", GlobalCollectionFilters);

customElements.define(
  "global-collection-filters-header",
  CollectionFiltersHeader
);

customElements.define(
  "collection-quick-filter-buttons",
  CollectionQuickFilterButtons
);

customElements.define(
  "global-collection-filters-flyout",
  CollectionFiltersFlyout
);

customElements.define("filters-flyout-prices", FiltersFlyoutPrices);
